import React, { useEffect, useState } from 'react';
import { Button, Alert, Spinner, Col, Row, } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postData, postDataLogin } from '../ApiServices/ApiService';
import NavHeader from './NavHeader';
import LatestInterviews from './LatestInterviews';
import { FaCircleCheck } from "react-icons/fa6";
import { GoXCircleFill } from "react-icons/go";
import { BiLeftArrowAlt } from "react-icons/bi";

const JobDetailsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // const location = useLocation();
  const jobId = searchParams.get('id');
  // const jobDetails = location.state?. jobDetails|| "";
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
  const [jdDetailsList, setJobDetailsList] = useState([]);
  const [testList, settestList] = useState([])
  const [isEditable, setEditable] = useState(false);
  const [editedJobDescription, setEditedJobDescription] = useState('');
  const [showMore, setShowMore] = useState(false);
  const category =searchParams.get('category');
  const [selectCategory,setSelectCategory]=useState('')
  


  useEffect(() => {   
    jobDetailsList();
  }, [])

    useEffect(() => {   
    if(category === 'undefined' || category === 'null'){
      setSelectCategory('TECHNOLOGY')
     
    }else{
      setSelectCategory(category);
      
    }
  }, [])

  const jobDetailsList = async () => {
    setJobDetailsList([])
    setSuccess('');
    const payload = {
      "company_id": aminInfo?.organization_id,
      "job_id": jobId,
      "user_id": aminInfo?.user_id
    };
    //   setLoading(true)
    // return
    try {
      await postData('admin_in/job/get-job-details', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
        if (respData.statusCode === 200) {
          if (respData.message.toLowerCase() === 'success') {
            setJobDetailsList(respData.dataJ[0]);
            
            setLoading(false);
            //setSuccess(resp.info);
          } else {
            setLoading(false);
            setSuccess(respData.info);
          }

        } else if (respData.statusCode === 500) {
          setLoading(false);
          setSuccess(respData.info);
        } else {
          setLoading(false);
          setSuccess('Job Details failed. Please check your credentials.');
        }
      }
      else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
        console.log('resp status else if : ', resp.status);
        if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
          || respData.message === 'Access Denied') {
            setLoading(false);
          //   callRefreshTokenApi('getSfeBatch', '');
        }
        setSuccess('Looks Like Session Expired Please login..');
      }else {
        console.log('resp status else  : ', resp);
        setLoading(false);
      }
    }).catch((error) => {
      setSuccess('Network Error');
      console.log('network error:', error);
      setLoading(false);
    });
        
      }).catch((error) => {
        setLoading(false);
        setSuccess('JobDetails failed. Please check your credentials or Network Error');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }

  useEffect(() => {
    const interviewDetailsList = async () => {
      settestList([])
      setSuccess('');
      // const orgID =localStorage.getItem('org_id')
      const payload = {
        // "op":"job_id_input",
        "user_id": aminInfo?.user_id,
        "job_id": jobId
      };
      setLoading(true)
      // return
      try {
        // await  postDataLogin('/admin_in/candidate_dashbord',payload).then(resp => {
        await postData('admin_in/candidate-interview/get-interview-query', payload).then(respData => {
          respData.json().then(resp => {
            if (respData.status === 200) {
          if (resp.statusCode === 200) {
            if (resp.message.toLowerCase() === 'success') {
              settestList(resp.dataJ);
              setLoading(false);
              //setSuccess(resp.info);
            } else {
              setLoading(false);
              setSuccess(resp.info);
            }

          } else if (resp.statusCode === 500) {
            setLoading(false);
            setSuccess(resp.info);
          } else {
            setLoading(false);
            setSuccess('Test Details failed. Please check your credentials.');
          }
        }
        else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
              setLoading(false);
            //   callRefreshTokenApi('getSfeBatch', '');
          }
          setSuccess('Looks Like Session Expired Please login..');
        }else {
          if (respData.message === 'Unauthorized' ){
            setLoading(false);
            console.log('resp status else  : ', resp);
            setSuccess('Looks Like Session Expired Please login..');
          }else{
            setLoading(false);
            console.log('resp status else  : ', resp);
            setSuccess('Looks Like Session Expired Please login..');
          }
          // setSuccess('Looks Like Session Expired Please login..');
          // console.log('resp status else  : ', resp);
          // setLoading(false);
        }
      }).catch((error) => {
        setSuccess('Interview Details failed. Please check your credentials or Network Error');
        console.log('network error:', error);
        setLoading(false);
      });
        }).catch((error) => {
          setLoading(false);
          setSuccess('Interview Details failed. Please check your credentials or Network Error!');
          console.log('network error:', error);

        });
      } catch (error) {
        setLoading(false);
        setSuccess('Interview Details failed. Please check your credentials or Network Error!!');
        // Handle login error, e.g., display an error message to the user.
        console.error('Test Details failed', error);
      }
    }
    interviewDetailsList();
  }, [])


  const addCandidate = (job_id) => {
    navigate(`/candidate?id=${job_id}`)

  }

  const handleEditClick = () => {
    // setEditable(true);
    setEditedJobDescription(jdDetailsList?.jd_of_candidate_input);
    navigate(`/add-job-post?id=${jobId}`,{ state: { jobInfo:jdDetailsList } });
  };


  const backButton =()=>{
    navigate(`/job-post`);
  }

  const handleStopJob = async () => {
    const confirmStopJob = window.confirm('Are you sure you want to Close this Job?'); 
    if(confirmStopJob){
      const payload = {
        "user_id": aminInfo?.user_id,
        "job_id": jobId,
        "job_status":"CLOSED", // NEW,INPROGRESS,CLOSED
        "op": "update_job_status",
      }
      console.log('payload',payload);
      setLoading(true)
      // try {
      //   await postDataLogin('admin_in/job/update-job-details', payload).then(resp => {
      //     if (resp.statusCode === 200) {
      //       if (resp.message.toLowerCase() === 'success') {             
      //         setLoading(false);
      //         jobDetailsList();
      //       } else {
      //         setLoading(false);
      //         setSuccess(resp.info);
      //       }
  
      //     } else if (resp.statusCode === 500) {
      //       setLoading(false);
      //       setSuccess(resp.info);
      //     } else {
      //       setLoading(false);
      //       setSuccess('Close Job is  failed. Please check your credentials.');
      //     }
      //   }).catch((error) => {
      //     setLoading(false);
      //     setSuccess('Close Job failed. Please check your credentials or Network Error');
      //     console.log('network error:', error);
  
      //   });
      // } catch (error) {
      //   setLoading(false);
      //   console.error('Close Job failed', error);
      // }
      try {
        await postData('admin_in/job/update-job-details', payload).then(resp => {
          resp.json().then(respData => {
            if (resp.status === 200) {
          if (respData.statusCode === 200) {
            if (respData.message.toLowerCase() === 'success') {
              setLoading(false);
              jobDetailsList();
              navigate(`/job-post`);

              //setSuccess(resp.info);
            } else {
              setLoading(false);
              setSuccess(respData.info);
            }
  
          } else if (respData.statusCode === 500) {
            setLoading(false);
            setSuccess(respData.info);
          } else {
            setLoading(false);
            setSuccess('Close Job is  failed. Please check your credentials.');
          }
        }
        else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
              setLoading(false);
            //   callRefreshTokenApi('getSfeBatch', '');
          }
          setSuccess('Looks Like Session Expired Please login..');
        }else {
          console.log('resp status else  : ', resp);
          setLoading(false);
        }
      }).catch((error) => {
        setSuccess('Network Error');
        console.log('network error:', error);
        setLoading(false);
      });
          
        }).catch((error) => {
          setLoading(false);
          setSuccess('Close Job is  failed. Please check your credentials.');
          console.log('network error:', error);
  
        });
      } catch (error) {
        setLoading(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Job Details failed', error);
      }
    }else{
      console.log('confirmStopJob',confirmStopJob)
    }

  }



  return (
    <div className='dashboard-div ' style={{ overflowX: 'hidden' }}>
      <NavHeader></NavHeader>
      <div className=''>

        <div className='candidate-title'>Job Details</div>
        <div className='job-div-width'>
        <BiLeftArrowAlt  style={{fontSize:'30px',cursor:'pointer'}} onClick={backButton}/>
          <div className='job-info-div' style={{ fontWeight: 'bold' }}>
            <Row style={{ padding: 5 }}>
              <Col>
                {/* <div ><span className='info-title'>JobID:</span> <span className='info-data'>{jdDetailsList?.job_id}</span></div> */}
                <div ><span className='info-title'> Job ID:</span> <span className='info-data'>{jdDetailsList?.job_rec_id}</span></div>
                <div><span className='info-title'>Job Name:</span> <span className='info-data'>{jdDetailsList?.job_name}</span></div>   
                <div><span className='info-title'>Job Client:</span> <span className='info-data'>{jdDetailsList?.client_name}</span></div>
                <div><span className='info-title'>Openings:</span> <span className='info-data'>{jdDetailsList?.openings_count}</span></div>
                <div><span className='info-title'>Job Status:</span> <span className='info-data'>{jdDetailsList?.job_status}</span></div>
                <div><span className='info-title'>Category:</span> <span className='info-data'>{selectCategory}</span></div>
                {/* <div><span className='info-title'>Status:</span> <span className='info-data'>{jdDetailsList?.job_status}</span></div> */}
                {/* <div> <span className='info-title'>Skills:</span><span className='info-data'>{jdDetailsList?.job_skills}</span></div> */}
              </Col>
              <Col>
                {/* <div><span className='info-title'>Start Date:</span> <span className='info-data'>{jdDetailsList?.job_start_date}</span></div> */}
                {/* <div><span className='info-title'>End Date:</span> <span className='info-data'>{jdDetailsList?.job_end_date}</span></div> */}
                {/* <div>
                  {isEditable ? (
                    <>
                      <legend className="scheduler-border-ing">
                        <div className="" style={{ backgroundColor: '#fff', fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>Job Description</div>
                      </legend>
                      <textarea
                        style={{ width: '100%' }}
                        value={editedJobDescription}
                        onChange={(e) => setEditedJobDescription(e.target.value)}
                      />
                    </>) : (
                    <div className='description-div'>
                      <span className='info-title' >Job Description:</span>
                      {jdDetailsList?.jd_of_candidate_input != 'NA' && <span className='info-data'>
                          {showMore
                            ? jdDetailsList?.jd_of_candidate_input || ""
                            : jdDetailsList?.jd_of_candidate_input
                              ? jdDetailsList.jd_of_candidate_input.substring(0, 200)
                              : ""}
                          {jdDetailsList?.jd_of_candidate_input && jdDetailsList.jd_of_candidate_input.length > 200 && (
                            <button className="text-show-btn" onClick={() => setShowMore(!showMore)}> {showMore ? 'Show less':'Show more'} </button>
                          )}
                        </span>}
                 
                    </div>)}
                </div> */}
                   {(jdDetailsList.ai_question_type === 1 && selectCategory !=='HOSPITALITY')&& <div><span className='info-title'>Tech-Questions </span><span><FaCircleCheck className='font-size-12 color-green' /></span> </div>}
                {jdDetailsList.recuiter_questions_type === 1 && <div><span className='info-title'>Client-Questions </span><span><FaCircleCheck className='font-size-12 color-green' /></span></div>}
                {jdDetailsList.jd_questions_type === 1 && <div><span className='info-title'>Job Description(JD) </span><span><FaCircleCheck className='font-size-12 color-green' /></span></div>}
                {(jdDetailsList.ai_question_type === 0 && selectCategory !=='HOSPITALITY')&& <div><span className='info-title'>Tech-Questions </span><span><GoXCircleFill className='font-size-12 color-red' /></span> </div>}
                {jdDetailsList.recuiter_questions_type === 0 && <div><span className='info-title'>Client-Questions </span><span><GoXCircleFill className='font-size-12 color-red' /></span></div>}
                {jdDetailsList.jd_questions_type === 0 && <div><span className='info-title'>Job Description(JD) </span><span><GoXCircleFill className='font-size-12 color-red' /></span></div>}
                {(jdDetailsList?.coding_q_enabled === 1 && selectCategory !=='HOSPITALITY')&& <div><span className='info-title'>Coding-Questions </span><span><FaCircleCheck className='font-size-12 color-green' /></span></div>}
                {(jdDetailsList?.coding_q_enabled === 0 && selectCategory !=='HOSPITALITY')&& <div><span className='info-title'>Coding-Questions </span><span><GoXCircleFill className='font-size-12 color-red' /></span> </div>}
                
                {jdDetailsList.ai_question_type === 1 &&
                  <div><span className='info-title'>Technologies:</span>
                    {jdDetailsList.technologies ? (
                      <span className='info-data'>
                        {Object.keys(jdDetailsList.technologies).map((tech, index, array) => (
                          <span key={index}>{tech} {index < array.length - 1 && ', '}</span>
                        ))}
                      </span>
                    ) : (
                      <span className='info-data'></span>
                    )}</div>}

                  {jdDetailsList.coding_q_enabled === 1 &&
                  <div><span className='info-title'>Coding Technologies: </span>
                  <span className='info-data'>{jdDetailsList?.coding_q_tech}</span>
                   </div>}
                {jdDetailsList.recuiter_questions_type === 1 &&
                  <div><span className='info-title'>Client Questions:</span> <span className='info-data'>{jdDetailsList?.recuiter_questions_input}</span></div>}
                {/* <div><span className='info-title'>Job Client:</span> <span className='info-data'>{jdDetailsList?.job_client}</span></div>     */}
              </Col>
              <Col md={2}>
                <div className='can-btn-div'>
                  {/* <Link to={`/candidate?id=${jdDetailsList?.job_id}`}  className="Button-add" style={{textDecoration:'none'}}>Add Candidate </Link> */}
                  {/* <Button className="Button-add" style={{ backgroundColor: 'black' }} disabled> Code Test</Button> */}
                </div>
                <div className='can-btn-div'>
                  {/* <Link to={`/candidate?id=${jdDetailsList?.job_id}`}  className="Button-add" style={{textDecoration:'none'}}>Add Candidate </Link> */}
                  {/* <Button onClick={() => addCandidate(jdDetailsList?.job_id)} className="Button-add" style={{ backgroundColor: 'black' }}>Schedule Interview</Button> */}
                </div>
           
                {jdDetailsList?.job_status === 'NEW'  &&                   <div className='can-btn-div'>
                    <Button onClick={handleEditClick} className="Button-add" style={{ backgroundColor: 'black' }}>
                      Edit Job
                    </Button>
                  </div>}
                {jdDetailsList?.job_status === 'NEW' && <div className='can-btn-div'>
                    <Button onClick={handleStopJob} className="Button-add" style={{ backgroundColor: 'black' }}>
                      Close Job
                    </Button>
                  </div>}
              </Col>
            </Row>
          </div>
        </div>


        <div className='tables-div' style={{ marginTop: '50px' }}>
          <Row className='tables-div'>
            <Col>
              {success && <Alert variant="danger">{success}</Alert>}
              {loading && (
                <div className="spinner-overlay">
                  <Spinner animation="border" role="status">
                    <span className="sr-only"></span>
                  </Spinner>
                </div>
              )}


              {testList.length > 0 && (
                <div className="table-responsive" style={{ marginBottom: '15px' }}>
                  <LatestInterviews data={testList} category={selectCategory}/>
                </div>)}
            </Col>
          </Row>
        </div>

      </div>

    </div>
  )

}
export default JobDetailsPage